<template>
  <div class="use-case">

    <div class="text-container" v-for="(useCase, k) in useCases" :key="k">
      <h1 style="text-align: left">
        <img class="title-icon" :src="getFullIconPath(k)" alt="">
        {{useCase.title}}
      </h1>
      <h3 style="text-align: left">{{useCase.subTitle}}</h3>
      <p style="font-size: 18px;text-align: left"  v-html="useCase.description"></p>
      <p style="text-align: left;font-size: 12px" v-html="useCase.footNote"></p>
      <h3 style="text-align: left; margin-top: 36px">{{useCase.logoTitle}}</h3>
      <div class="logo-container">
        <div class="logo-item" v-for="(l, k) in useCase.logos" :key="k">
          <a target="_blank" :href="l.link">
            <img :src="require('@/assets/img/' + l.image)" alt="">
          </a>
        </div>
      </div>
    </div>

<!--    <div class="use-case-card" v-for="(useCase, k) in useCases" :key="k"-->
<!--         data-aos="fade-zoom-in"-->
<!--         data-aos-delay="100"-->
<!--         data-aos-easing="ease-out"-->
<!--         data-aos-duration="400"-->
<!--         data-aos-anchor-placement="top-bottom">-->
<!--      <div class="card-top">-->
<!--        <div class="dots-small"></div>-->
<!--        <div class="floating-bg">-->
<!--          <span>{{ useCase.title }}</span>-->
<!--          <span>{{ useCase.subTitle }}</span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="card-bottom">-->
<!--        <p v-html="useCase.description"></p>-->
<!--        <small v-html="useCase.footNote"></small>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UseCase',
  data () {
    return {
      useCases: null,
      icons: ['chef-hat', 'briefcase']
    }
  },
  methods: {
    fetchUseCases () {
      axios.get('/text.json').then(response => {
        this.useCases = response.data['use-cases']
      })
    },
    getFullIconPath (index) {
      return require('@/assets/img/' + this.icons[index] + '.svg')
    }
  },
  mounted () {
    this.fetchUseCases()
  }
}
</script>

<style scoped lang="scss">

  @media screen and (max-width: 800px) {
    .use-case-card {
      width: 100% !important;
    }

    .card-top {
      height: 152px !important;
    }

    .use-case {
      padding: 128px 24px !important;
    }
  }

  .use-case {
    display: flex;
    flex-direction: column;
    padding: 128px 48px 64px 48px;
    justify-content: center;
    align-items: center;

    .use-case-card {
      width: 100%;
      max-width: 900px;
      background-color: white;
      margin: 24px 0;
      border-radius: 4px;
      box-shadow: 0px 0px 8px 0px rgba(22, 31, 58, 0.2);
      display: flex;
      flex-direction: column;

      .card-top {
        position: relative;
        color: $text-light;
        height: 50px;
        padding: 24px;

        .floating-bg {
          position: absolute;
          background-color: $primary-dark-blue;
          box-shadow: 0px 0px 12px 0px rgba(22, 31, 58, 0.5);
          top: -4px;
          right: -4px;
          bottom: -4px;
          left: -4px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          span {
            font-weight: 500;
            padding: 0 24px;
            font-size: 22px;
          }

          span:nth-child(even) {
            font-size: 18px;
            margin-top: 12px;
          }
        }
      }

      .card-bottom {
        text-align: justify;
        padding: 24px;

        p {
          font-size: 18px;
          margin: 0;
        }
      }
    }
  }

  .text-container {
    padding: 36px 48px;
    max-width: 800px;
    h1 {
      display: flex;
      align-items: center;
      .title-icon {
        width: 36px;
        height: 36px;
        margin-right: 12px;
      }
    }
    p {
      line-height: 26px;
    }
  }

  .logo-container {
    padding: 48px 0;
    margin: auto;
    max-width: 700px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .logo-item {
    margin: 24px;
    flex-grow: 1;
    img {
      width: 200px;
      transition: 0.4s ease all;
      filter: grayscale(1);
    }

    img:hover {
      filter: grayscale(0) drop-shadow(0 2px 12px transparentize($background-dark, 0.8));
    }
  }
</style>
